
export function getRealUnitPrice(item) {
  const { cataloguePrice, regularUnitPrice, regularOptionsPrice } = item;

  return (cataloguePrice || regularUnitPrice) +
    (regularOptionsPrice || 0);
}

export function calculateAgentPercentDiscount({agentUnitPrice, item}) {
  if (!agentUnitPrice)
    return 0;

  const fullPrice = getRealUnitPrice(item);

  const discountCents = fullPrice - agentUnitPrice;

  let percent = 100.0 * (fullPrice - discountCents) / fullPrice;
  return 100.0 - percent;
}

export function calculateDiscount({discountPercent, fullPrice, item}) {
  fullPrice ||= getRealUnitPrice(item);

  if (!discountPercent || isNaN(discountPercent) || (discountPercent < 0)) {
    return fullPrice;
  }

  let discount = fullPrice * discountPercent / 100.0;
  return Math.round(discount);
}

